<template>
  <component v-bind:is="component" />
</template>

<script>
import { mapState } from 'vuex'

import BankSlip from './BankSlip'
import ScheduledDebit from './ScheduledDebit'
import Pix from './Pix'

export default {
  name: 'NonInstantPaymentsIndex',
  components: {
    BankSlip,
    ScheduledDebit,
    Pix
  },
  computed: {
    ...mapState(['device']),
    component () {
      return this.handleTypePayment(this.device.payment.typePayment)
    }
  },
  methods: {
    handleTypePayment (type) {
      return type.split('_').map((el) => {
        return el.charAt(0).toUpperCase() + el.slice(1).toLowerCase()
      }).join('')
    }
  }
}
</script>

<style scoped>

</style>
